import React from 'react';
import { observer } from 'mobx-react-lite';
import { ChipsContainer, freeBetStore } from '@pascal/pascal-core';
import { doBetStore } from '../../store/doBetStore';
import { gameStore } from '../../store/gameStore';

const ChipsWrapper = observer(() => {
  const { selectedChip, setSelectedChip, quickBets } = doBetStore;
  const { isBetsClosed } = gameStore;
  const { activeFreeBet } = freeBetStore;

  const handleSelectChips = (chip) => {
    setSelectedChip(chip);
  };

  if (isBetsClosed) {
    return null;
  }
  return (
    <ChipsContainer
      selectedChip={selectedChip}
      handleSelectChips={handleSelectChips}
      quickBets={quickBets}
      isFreeChip={!!activeFreeBet.id}
    />
  );
});
export default ChipsWrapper;
